// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
// const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// if (!SUPABASE_URL) {
//   throw new Error('Missing environment variable: VITE_SUPABASE_URL');
// }

// if (!SUPABASE_PUBLISHABLE_KEY) {
//   throw new Error('Missing environment variable: VITE_SUPABASE_PUBLISHABLE_KEY');
// }



const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
  || "https://pqcfyqzvjpxfgjjbdoft.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY
  || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBxY2Z5cXp2anB4ZmdqamJkb2Z0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MzE2NjMsImV4cCI6MjA2OTMwNzY2M30.eFQKcnP1jYp8SS4toFzbWQyyudBm6G7VmifqWkQ6MrY";

  

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: typeof localStorage !== 'undefined' ? localStorage : undefined,
    persistSession: true,
    autoRefreshToken: true,
  }
});